import { defineElement, html, TemplateElement, unsafeHTML } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-bento-box/e-banking-bento.js';
import { mapNodes } from '@/mgnl/utils/magnolia.js';
import { getImageAttributes } from '@/services/content-service.js';

class EditableBento extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { environment: null };
    }

    get landscapeCard() {
        const landscapeCard = this.content?.landscapeCard || {};

        return {
            text: landscapeCard.text ?? null,
            color: landscapeCard.color ?? null,
            kicker: landscapeCard.kicker ?? null,
            title: landscapeCard.title ?? null,
            image: landscapeCard.image
                ? getImageAttributes(this.environment, landscapeCard.image, 150)
                : null,
        };
    }

    template() {
        return html` <mb-e-banking-bento .headline="${this.content.headline}" .landscapeCard="${this.landscapeCard}" .squareCard1="${this.content.squareCardOne}" .squareCard2="${this.content.squareCardTwo}"></mb-e-banking-bento> `;
    }
}

defineElement('editable-bento', EditableBento);
